import { observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

import { evaluateAndLogExperiment } from 'src/common/stores/utils';

import { FilterModel, FilterOptionModel } from 'components/common/search-form/fields/filter-types';

import { UitkSelect } from 'uitk-react-input';

import { FormFieldBinding } from 'components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

const TrackedSelect = ClickTracker(UitkSelect);

@FormFieldBinding
@observer
export class SelectField extends React.Component<SearchFormFieldProps> {
  private optionRef;

  constructor(props) {
    super(props);
    this.optionRef = [];
  }

  private handleChange = event => {
    const value = event.target.value;
    const { analytics, model, modelKey, sortAndFilterOptions, updateModel } = this.props;

    const select: FilterModel = sortAndFilterOptions && sortAndFilterOptions[modelKey];
    const selectName: string = select && select.title;
    const modelValue = model && model[selectName];

    if (typeof updateModel !== 'function' || typeof modelValue === 'undefined') {
      return;
    }

    updateModel({
      target: {
        name: selectName,
        value,
      },
    });

    if (typeof analytics?.trackEvent === 'function') {
      const selectionRfrrId = `${selectName}.SELECTION.${value}`;
      analytics.trackEvent(selectionRfrrId, selectionRfrrId, null);
    }
  };

  private handleClick = (event): void => {
    const { context, experiment, page } = this.props;

    if (event.currentTarget.id === 'sort') {
      evaluateAndLogExperiment('Update_Guest_Rating_sort_option_to_non_ML_Model', context, experiment, page);
    }
  };

  public render() {
    const { model, modelKey, sortAndFilterOptions } = this.props;
    const select = sortAndFilterOptions && sortAndFilterOptions[modelKey];
    const selectName: string = select && select.title;
    const selectOptions: FilterOptionModel[] = select && select.options;

    const value = (model && model[selectName]) || '';

    if (!selectOptions || selectOptions.length === 0) {
      return null;
    }
    const currentRfrrId = `${selectName}.CURRENT.${value}`;

    return (
      <fieldset>
        <TrackedSelect
          defaultValue={value}
          label={<LocalizedText message="hotels.searchResults.filtersDialog.sort.label" />}
          linkName={currentRfrrId}
          name={selectName}
          onChange={this.handleChange}
          onClick={this.handleClick}
          rfrr={currentRfrrId}
          value={value}
          id={modelKey}
        >
          {selectOptions.map((option, index) => (
            <option
              key={`${selectName}-${index}-${option.value}`}
              value={option.value}
              ref={optionRef => (this.optionRef[option.value] = optionRef)}
            >
              {option.label}
            </option>
          ))}
        </TrackedSelect>
      </fieldset>
    );
  }
}
